/* eslint-disable default-case */
const initialState = {
  organisation: [],
  organisationById: [],
  organisationByPartnerId: [],
  total: "0",
  modalDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  modalData: {
    emableModel: false,
    message: "",
    displayMsg: "",
    enableCancelButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  tableLoading: false,
  sidebarLoading: false,
  modulePermissions: {},
  totalPages: 0,
  currentPage: 1,
  totalItems:0,
  partnersList: [] ,
  searchOptions: {},
};

const OrganisationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_ORGANISATION":
      return {
        ...state,
        organisation: payload || [],
      };
    case "GET_ORGANISATION_BY_ID":
      return {
        ...state,
        organisationById: payload,
      };
    case "DELETE_ORGANISATION":
      return {
        ...state,
        organisation: state.organisation.filter(({ id }) => id !== payload),
      };
    case "UPDATE_ORGANISATION":
      const organisationId = payload.id;
      return {
        ...state,
        organisation: state.organisation.map((org) => {
          return org.id === organisationId ? payload : org;
        }),
      };
    case "GET_ORGANISATION_BY_PARTNER_ID":
      return {
        ...state,
        organisationByPartnerId: payload,
      };
    case "SEARCH_ORGANISATION":
      return {
        ...state,
        organisation: payload.content || [],
        currentPage: payload.page,
        totalItems: payload.totalItems,
        totalPages: payload.totalPages

      };
    case "FILTER_ORGANISATION_DATA":
        let value = payload
        let filteredData = []
        if(value.length){
            filteredData = state.organisation
                .filter((item) => {
                    let startsWithCondition = 
                        item.name.toLowerCase().startsWith(value.toLowerCase())
                    let includesCondition = 
                        item.name.toLowerCase().includes(value.toLowerCase())
                    if(startsWithCondition){
                        return startsWithCondition;
                    } else if (!startsWithCondition && includesCondition) {
                        return includesCondition
                    } else {
                        return null;
                    }
                })
                return { ...state, filteredData }
        } else {
            filteredData = state.organisation
            return { ...state, filteredData }
        }
        return {...state, filteredData}  
    case "OPEN_MODEL":
      return {
        ...state,
        modalData: action.value,
      };
    case "OPEN_MODEL_DELETE":
      return {
        ...state,
        modalDeleteData: payload,
      };
    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload
      } 
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload
      }  
    case "MODULE_PERMISSIONS": {
      return {
        ...state,
        modulePermissions: payload
      }
    }  
    case "SAVE_ORGANISATION": {
      // if(Array.isArray(state.organisation)) {
      //   return state.organisation
      // }
      return {
        organisation:[ ...state.organisation, payload], 
        total: state.total + 1
      }
    }
    case "SET_SEARCH_OPTIONS":
      return {
        ...state,
        searchOptions: payload,
      };
    default: {
      return state;
    }
  }
};

export default OrganisationReducer;
